import React, { useState } from "react";
import "./AdminLoginScreen.css";
import BackButton from "../../../components/BackButton/BackButton";
import Button from "../../../components/Button/Button";
import Header from "../../../components/Header/Header";
import TextInput from "../../../components/TextInput/TextInput";
import { emailValidator } from "../../../helpers/emailValidator";
import { passwordValidator } from "../../../helpers/passwordValidator";
/** Firebase Imports **/
import {
	auth,
	signInWithEmailAndPassword,
	db,
	collection,
	query,
	where,
	getDocs,
} from "../../../firebaseConfig";
import { logIn, useDispatch } from "../../../features/userSlice";
import { showError } from "../../../helpers/showError";
/** **/

const AdminLoginScreen = () => {
	const dispatch = useDispatch();

	const [email, setEmail] = useState({ value: "", error: "" });
	const [password, setPassword] = useState({ value: "", error: "" });
	const [isProcessing, setIsProcessing] = useState(false);

	/**
	 * Main Functions
	 */
	const handleLogin = async () => {
		setIsProcessing(true);
		const emailError = emailValidator(email.value);
		const passwordError = passwordValidator(password.value);
		if (emailError || passwordError) {
			setEmail({ ...email, error: emailError });
			setPassword({ ...password, error: passwordError });
			return;
		}

		const usersRef = collection(db, "users");
		const q = query(usersRef, where("isAdmin", "==", true));
		const querySnapshot = await getDocs(q);
		if (querySnapshot.docs[0].data().email === email.value) {
			signInWithEmailAndPassword(auth, email.value, password.value)
				.then(async (userCredential) => {
					dispatch(
						logIn({
							uid: userCredential.uid,
							email: userCredential.email,
							name: userCredential.displayName,
							role: "admin",
						})
					);
					setIsProcessing(false);
					// alert("Successful Login");
					// navigate("/landing");
				})
				.catch((error) => {
					setIsProcessing(false);
					showError(error);
				});
		} else {
			alert("---- Error ----\n Invalid credentials for admin login");
			setIsProcessing(false);
		}
	};
	/** **/

	return (
		<div className="h-full w-full m-0 px-3 py-8 flex flex-col items-center">
			<BackButton target={"/admin"} className="mr-auto" />
			<Header className={"my-8 mr-auto"} size={"large"}>
				Log In
			</Header>
			<TextInput
				className={"my-2 shadow-none mx-auto"}
				type={"text"}
				name={"email"}
				id={"email"}
				placeholder={"Email"}
				value={email.value}
				onChange={(e) => {
					setEmail({ value: e.target.value, error: "" });
				}}
				error={email.error !== ""}
				errorMessage={email.error}
			/>
			<TextInput
				className={"my-2 shadow-none mx-auto"}
				type={"password"}
				name={"password"}
				id={"password"}
				placeholder={"Password"}
				value={password.value}
				onChange={(e) => {
					setPassword({ value: e.target.value, error: "" });
				}}
				error={password.error !== ""}
				errorMessage={password.error}
			/>
			<Button
				className={"my-2 mx-auto"}
				title={isProcessing ? "ooo" : "LOG IN"}
				disabled={isProcessing}
				mode={"filled"}
				size={"full"}
				onClick={(e) => handleLogin()}
			/>
		</div>
	);
};
export default AdminLoginScreen;
